import { gql } from '@apollo/client';

export const switchFocusMutation = gql`
    mutation SwitchFocus(
      $questId: String!, 
      $timerValueInMs: Int!) 
    {
        updateQuest(
          data: {
            id: $questId,
            timerValueInMs: $timerValueInMs,
          }) 
        {
            id
            timerValueInMs
        }
    }
`;